import type { CSSProperties } from "react";
import { EXACT_ICON_BODIES } from "./iconifyBodies";

interface ActionNeededIconProps {
  size?: number;
  className?: string;
  title?: string;
  style?: CSSProperties;
}

export function ActionNeededIcon({
  size = 16,
  className,
  title = "Action needed",
  style,
}: ActionNeededIconProps) {
  const glyph = EXACT_ICON_BODIES["action-needed-preview"];

  return (
    <span
      className={className}
      style={{
        display: "inline-flex",
        width: size,
        height: size,
        alignItems: "center",
        justifyContent: "center",
        color: "currentColor",
        ...style,
      }}
      title={title}
      aria-hidden="true"
    >
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${glyph.width} ${glyph.height}`}
        dangerouslySetInnerHTML={{ __html: glyph.body }}
      />
    </span>
  );
}
